<template>
  <div class="flex flex-col items-center justify-center p-4 h-full text-center relative">
    <ParticleAnimation class="absolute inset-0 pointer-events-none" />
    <p
      v-motion
      class="font-bold text-3xl @sm/chat:text-4xl @md/chat:text-5xl bg-linear-to-r from-blue-600 dark:via-primary to-primary-400 dark:to-primary-400 bg-clip-text text-transparent opacity-0 duration-1000 pb-1 not-supports-cq:sm:text-4xl not-supports-cq:md:text-5xl"
      :initial="{ opacity: 0, y: 10 }"
      :enter="{ opacity: 1, y: 0 }"
    >
      {{ $t(timeOfDay) }}
    </p>
    <div
      class="relative font-semibold text-sm @sm:text-base @md:text-lg mb-6 not-supports-cq:sm:text-base not-supports-cq:md:text-lg"
    >
      <p class="opacity-0 pointer-events-none">
        {{ $t("howCanBotHelpToday") }}
      </p>
      <p class="absolute top-0 left-0 text-slate-800/30 dark:text-slate-200/30">
        {{ $t("howCanBotHelpToday") }}
      </p>
      <p class="absolute top-0 left-0">
        <StreamedText
          auto-hide-caret
          :text="$t('howCanBotHelpToday')"
          :duration="0.7 * SECOND"
          :delay="200"
        />
      </p>
    </div>
    <AppButton
      :label="$t('wordsRecent')"
      icon-pos="left"
      icon="pi pi-bars"
      outlined
      variant="secondary"
      @click="emit('showRecents')"
    />

    <div
      class="flex flex-col items-center text-sm absolute bottom-8 text-surface-400 dark:text-surface-400"
    >
      <p class="text-sm mb-6">{{ $t("v2ChatInstruction") }}</p>
      <i
        class="pi pi-chevron-down h-2 opacity-0 animate-[fade-in-down_1.6s_ease-in-out_infinite]"
      />
      <i
        class="pi pi-chevron-down h-2 opacity-0 animate-[fade-in-down_1.6s_ease-out_infinite]"
      />
    </div>

    <!-- <ConversationStarterSuggestions /> -->
  </div>
</template>

<script setup lang="ts">
import ParticleAnimation from "@/components/effects/ParticleAnimation.vue";
import StreamedText from "@/components/shared/StreamedText.vue";
// import ConversationStarterSuggestions from "./ConversationStarterSuggestions.vue";

const emit = defineEmits(["showRecents"]);

const timeOfDay = computed(() => getTimeOfDay());

function getTimeOfDay() {
  const hour = new Date().getHours();
  if (hour < 12) {
    return "greetingGoodMorning";
  } else if (hour < 17) {
    return "greetingGoodAfternoon";
  } else {
    return "greetingGoodEvening";
  }
}
</script>
